import { BackgroundImage, Container, Image } from "../../components";
import {
  aboutUs as aboutUsAssets,
  gallery as galleryAssets,
  service as serviceAssets,
} from "../../assets";
import {
  Box,
  Button,
  Grid2,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export const Service = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUrl = `https://www.bluesagepools.com${location.pathname}`;

  return (
    <>
      <Helmet>
        <title>
          Pool Maintenance, Repair & Installation Services | Blue Sage Pools
        </title>
        <meta
          name="description"
          content="Discover expert pool maintenance, repair, and installation services. Blue Sage Pools offers weekly plans, discounted rates, and reliable care for a pristine pool."
        />
        <meta
          name="keywords"
          content="pool maintenance, pool repair, pool installation, weekly pool maintenance, Blue Sage Pools, pool service plans, pool equipment repair, pool cleaning, DFW area pool services"
        />
        <meta
          property="og:title"
          content="Pool Maintenance, Repair & Installation Services | Blue Sage Pools"
        />
        <meta
          property="og:description"
          content="Discover expert pool maintenance, repair, and installation services. Blue Sage Pools offers weekly plans, discounted rates, and reliable care for a pristine pool."
        />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={aboutUsAssets.blueSagePoolCover} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Pool Maintenance, Repair & Installation Services | Blue Sage Pools"
        />
        <meta
          name="twitter:description"
          content="Discover expert pool maintenance, repair, and installation services. Blue Sage Pools offers weekly plans, discounted rates, and reliable care for a pristine pool."
        />
        <meta name="twitter:image" content={aboutUsAssets.blueSagePoolCover} />
        <link rel="canonical" href={currentUrl} />
      </Helmet>

      <Button
        variant="contained"
        onClick={() => navigate("/schedule-now")}
        sx={{
          p: 1.5,
          position: "fixed",
          zIndex: "9999",
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          top: "70%",
          transformOrigin: "left top",
          rotate: "270deg",
        }}
      >
        Schedule Now
      </Button>
      <BackgroundImage
        sx={{ height: "45vh" }}
        src={aboutUsAssets.blueSagePoolCover}
        alt="Blue Sage Pools"
      />
      <Container sx={{ my: { xs: 5, sm: 10, md: 15 } }}>
        <Grid2 container spacing={4}>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption">we know pools!</Typography>
            <Typography sx={{ my: 4 }} variant="h3">
              Weekly Pool Maintenance
            </Typography>
            <Typography variant="h5" sx={{ textTransform: "uppercase", mb: 2 }}>
              Sign up for Weekly Maintenance and get control of your pool
            </Typography>
            <Typography variant="paragraph">
              <strong>Weekly Maintenance -</strong> We’ve maintained tens of
              thousands of pools across the DFW area, and our proven methods
              help prevent algae, staining, and other water quality issues. Our
              trained technicians provide consistent, professional service—
              ensuring your pool is clean, balanced, and visually inspected each
              week.
            </Typography>
            <Typography variant="paragraph">
              <strong>Proactive Equipment Monitoring -</strong> As part of our
              weekly maintenance, our techs are trained to visually inspect your
              pool equipment and structure. They flag early warning signs of
              potential issues—such as pump wear, filter pressure changes, or
              structural concerns—so you can address them before they become
              costly problems. We do not perform repairs, but we help keep you
              informed and prepared.
            </Typography>
            <Typography variant="paragraph">
              <strong>Full-Service Collaboration -</strong> Our maintenance team
              works closely with our construction and remodeling teams to share
              insight on pool health, performance, and water clarity. This
              collaboration helps us ensure your pool stays operating smoothly
              year-round.
            </Typography>
            <Typography variant="paragraph">
              <strong>Save Time, Save Money, Eliminate Frustration -</strong>
              Owning a pool should be enjoyable—not a source of stress. Our team
              helps you save time, protect your investment, and avoid
              unnecessary issues by maintaining your pool with diligence and
              care.
            </Typography>
            <Typography variant="paragraph">
              👉 Visit <strong>BlueSagePools.com</strong> or call
              <strong> 469-527-2583 </strong> to get started with a free quote.
            </Typography>
            <Box textAlign="center">
              <Button
                sx={{ py: 3, px: 4 }}
                onClick={() => navigate("/about-us")}
                variant="contained"
              >
                Read More
              </Button>
            </Box>
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 2, sm: 4, md: 6 },
            }}
          >
            <Image
              src={serviceAssets.side1}
              alt="Info Graphic"
              sx={{
                width: { xs: "100%", sm: "80%" },
                mx: "auto",
              }}
            />
            <Image
              src={serviceAssets.side2}
              alt="Info Graphic"
              sx={{
                width: { xs: "100%", sm: "80%" },
                mx: "auto",
              }}
            />
            <Image
              src={serviceAssets.side3}
              alt="Info Graphic"
              sx={{
                width: { xs: "100%", sm: "80%" },
                mx: "auto",
              }}
            />
          </Grid2>
        </Grid2>
      </Container>
      <BackgroundImage src={galleryAssets.topImage} alt="Blue Sage Pools">
        <Box sx={{ backgroundColor: "rgba(0,0,0,0.25)" }}>
          <Container
            sx={{
              py: { xs: 10, sm: 15, md: 20 },
            }}
          >
            <Typography
              variant="caption"
              color="common.white"
              sx={{
                "&::before": { backgroundColor: "common.white" },
              }}
            >
              All pools are not the same
            </Typography>
          </Container>
        </Box>
      </BackgroundImage>
      <Container sx={{ my: { xs: 4, sm: 6, md: 10 } }}>
        <Typography variant="h3" sx={{ mb: 4 }} textAlign="center">
          Interested in financing?
        </Typography>
        <Typography variant="paragraph">
          Since 1979, Lyon Financial has worked as a specialist in unsecured
          pool financing solutions. Unlike many banks and credit unions, our
          experience is unique to swimming pools, not just any type of loan.
          Your call will always be answered by a live, knowledgeable
          representative, eager to offer solutions. We are proudly veteran owned
          and operated, with special military programs available as a small
          gesture of our immense appreciation for our country’s heroes. Partner
          with the industry’s leader to make your backyard dreams come true!
        </Typography>
        <Image
          sx={{ my: { xs: 2, sm: 4 }, maxWidth: "50rem", mx: "auto" }}
          src={serviceAssets.lyonFinance}
          alt="Lyon Finance"
        />
        <Grid2 container spacing={4} sx={{ mt: { xs: 2, sm: 4, md: 6 } }}>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Image
              sx={{
                display: "flex",
                alignItems: "center",
                width: "80%",
                maxWidth: "50rem",
                mx: "auto",
              }}
              src={galleryAssets.geometric3}
              alt="Outdoor pool"
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <List>
              <ListItem sx={{ gap: 1 }}>
                <Typography variant="caption2">01.</Typography>
                <Typography variant="caption2" color="common.black">
                  Low fixed rates
                </Typography>
              </ListItem>
              <ListItem sx={{ gap: 1 }}>
                <Typography variant="caption2">02.</Typography>
                <Typography variant="caption2" color="common.black">
                  Loans up to $200,000‡
                </Typography>
              </ListItem>
              <ListItem sx={{ gap: 1 }}>
                <Typography variant="caption2">03.</Typography>
                <Typography variant="caption2" color="common.black">
                  Terms up to 30 years‡
                </Typography>
              </ListItem>
              <ListItem sx={{ gap: 1 }}>
                <Typography variant="caption2">04.</Typography>
                <Typography variant="caption2" color="common.black">
                  Special military programs available#
                </Typography>
              </ListItem>
              <ListItem sx={{ gap: 1 }}>
                <Typography variant="caption2">05.</Typography>
                <Typography variant="caption2" color="common.black">
                  No prepayment penalties
                </Typography>
              </ListItem>
              <ListItem sx={{ gap: 1 }}>
                <Typography variant="caption2">06.</Typography>
                <Typography variant="caption2" color="common.black">
                  No equity or appraisals required
                </Typography>
              </ListItem>
            </List>
          </Grid2>
          <Grid2 size={12} textAlign="center">
            <Button
              variant="contained"
              disableElevation
              disableRipple
              sx={{ py: 3, px: 4 }}
              onClick={() =>
                window.open("https://www.lyonfinancial.net/apply/", "_blank")
              }
            >
              Qualify Now!
            </Button>
          </Grid2>
        </Grid2>
      </Container>
    </>
  );
};
